import { CircularProgress } from "@mui/material";
import NavBar from "components/NavBar";
import { Container } from "components/styled";
import { useUserContext } from "components/UserContextProvider";
import React, { useState } from "react";

const iframeStyle = {
  border: 0,
  boxShadow: "none",
  flex: 1,
  width: "100vw",
  marginTop: 80,
};

const Community = () => {
  const { isAuthenticated: isLoggedIn } = useUserContext();
  const [isIframeLoading, setIsIframeLoading] = useState(true);

  return (
    <Container direction="column" height="100vh" style={{ flexFlow: "column" }}>
      <NavBar isCommunityPage />
      {isIframeLoading && (
        <Container style={{ flex: 1 }}>
          <CircularProgress />
        </Container>
      )}
      <iframe
        id="myIFrame"
        title="community-container"
        style={iframeStyle}
        onLoad={() => setIsIframeLoading(false)}
        src={
          isLoggedIn && process.env.REACT_APP_COMMUNITY_REDIRECT_URL
            ? process.env.REACT_APP_COMMUNITY_REDIRECT_URL
            : `https://community.healthinherhue.com?iframe=true`
        }
      />
    </Container>
  );
};

export default Community;
